import useToggle from "hooks/useToggle";
import { Button } from "reactstrap";
import { Tooltip, Whisper } from "rsuite";
import GrowthCloudLink from "./Link/GrowthCloudLink";

const CollapseIconLink = ({
  item,
  sidebarOpen,
  bold = true,
  extraPadding = false,
  type,
  customChildren = false,
}) => {
  const [open, toggleOpen] = useToggle();

  return (
    <>
      {sidebarOpen ? (
        <div
          className={`d-flex align-items-center justify-content-between ml-2 pl-2 mr-2 pt-1 cursor-pointer sidebar-link link-hovered ${
            open ? "pb-1" : "pb-1"
          }`}
          onClick={toggleOpen}
        >
          <div className="d-flex align-items-center">
            {item.icon ? (
              <i className={item.icon} style={{ fontSize: 18 }} />
            ) : null}
            {bold ? (
              <h5 className={`mb-0 ${item.icon ? "ml-2" : ""} ${item.color}`}>
                {item.name}
              </h5>
            ) : (
              <div className={`${item.icon ? "ml-2" : ""}`}>{item.name}</div>
            )}
          </div>
          <Button
            size="sm"
            outline
            color="secondary"
            className="btn-icon-only"
            style={{
              height: "1.5rem",
              width: "1.5rem",
              marginRight: "0.45rem",
            }}
          >
            <i
              className={`mdi mdi-chevron-${open ? "down" : "right"}`}
              style={{ fontSize: 20 }}
            />
          </Button>
        </div>
      ) : (
        <Whisper
          placement="right"
          controlId={`tooltipHover${item.id}`}
          trigger="hover"
          speaker={<Tooltip>{item.name}</Tooltip>}
        >
          <div
            className="d-flex justify-content-center cursor-pointer sidebar-link  px-2 py-1 mx-2 link-hovered"
            onClick={toggleOpen}
          >
            {open ? (
              <i className="mdi mdi-chevron-down" style={{ fontSize: 18 }} />
            ) : (
              <i className={item.icon} style={{ fontSize: 18 }} />
            )}
          </div>
        </Whisper>
      )}
      {open
        ? customChildren
          ? customChildren
          : item.children.map((child, i) => {
              if (child?.disabled) return null;

              return (
                <GrowthCloudLink
                  key={i}
                  title={child.name}
                  link={child.path}
                  type={type}
                  linkId={child.id}
                  extraPadding={extraPadding}
                  options={child.options}
                  icon={child.icon ? child.icon : ""}
                />
              );
            })
        : null}
    </>
  );
};

export default CollapseIconLink;
